import { biodiversityAreaUnitsNb } from "./biodiversityAreaUnits"
import { biodiversitySiteProximityNb } from "./biodiversitySiteProximity"
import { countriesNb } from "./countries"
import { ghgScopesNb } from "./ghgScopes"
import { pollutantMediaNb } from "./pollutantMedia"
import { pollutantsNb } from "./pollutants"
import { riskLevelsNb } from "./riskLevels"
import { riskTimeTermsNb } from "./riskTimeTerms"
import { scope3CategoriesNb } from "./scope3Categories"
import { sustainabilityIssuesNb } from "./sustainabilityIssues"
import { hazardousWasteTypesNb, nonHazardousWasteTypesNb } from "./wasteTypes"
import { wasteUnitsNb } from "./wasteUnits"
import { workforceCountingMethodsNb } from "./workforceCountingMethods"
import { yesNoNb } from "./yesNo"

/**
 * Registry mapping selectSource identifiers to their code→label lookup tables.
 *
 * Every select-source that appears in a KpiBreakdown.suffixSegments must have
 * a corresponding entry here so the UI can resolve raw codes (e.g. "SO2")
 * into human-readable labels (e.g. "Svoveldioksid").
 */
export const labelResolvers: Record<string, Record<string, string>> = {
  countriesNb,
  pollutantsNb,
  pollutantMediaNb,
  biodiversitySiteProximityNb,
  biodiversityAreaUnitsNb,
  wasteUnitsNb,
  hazardousWasteTypesNb,
  nonHazardousWasteTypesNb,
  workforceCountingMethods: workforceCountingMethodsNb,
  yesNoNb,
  sustainabilityIssuesNb,
  riskLevelsNb,
  riskTimeTermsNb,
  ghgScopesNb,
  scope3CategoriesNb,
}

/**
 * Resolve a raw code using the named selectSource.
 * Returns the human-readable label, or the raw code if no match is found.
 */
export function resolveLabel(selectSource: string | undefined, code: string): string {
  if (!selectSource) return code
  const lookup = labelResolvers[selectSource]
  return lookup?.[code] ?? code
}
